import { createElement } from "react";
import React from "react";
import * as react from "react";
import { useReact_useEffectOnce_3A5B6456, useFeliz_React__React_useState_Static_1505 } from "./fable_modules/Feliz.2.7.0/React.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "./fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "./fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { Auto_generateBoxedDecoderCached_Z6670B51, Auto_generateBoxedDecoder_Z6670B51 } from "./fable_modules/Thoth.Json.6.0.0/Decode.fs.js";
import { PreOpenMeta_$reflection, Post as Post_1, PostShortInfo, ShortEventPosition, User, Post_$reflection } from "./Types.js";
import { obj_type, array_type } from "./fable_modules/fable-library-js.4.17.0/Reflection.js";
import { PromiseBuilder__Delay_62FBFDE1 as PromiseBuilder__Delay_62FBFDE1_1, PromiseBuilder__Run_212F1D4B as PromiseBuilder__Run_212F1D4B_1 } from "./fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise as promise_1 } from "./fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { FetchError } from "./fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { FSharpResult$2 } from "./fable_modules/fable-library-js.4.17.0/Result.js";
import { Helper_fetch, Helper_withContentTypeJson, Helper_withProperties } from "./fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { singleton as singleton_1, cons, ofArray, empty } from "./fable_modules/fable-library-js.4.17.0/List.js";
import { Types_RequestProperties } from "./fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { keyValueList } from "./fable_modules/fable-library-js.4.17.0/MapUtil.js";
import { unwrap, map, defaultArg } from "./fable_modules/fable-library-js.4.17.0/Option.js";
import { toString } from "./fable_modules/Thoth.Json.6.0.0/Encode.fs.js";
import { Auto_generateBoxedEncoderCached_437914C6 } from "./fable_modules/Thoth.Json.6.0.0/Encode.fs.js";
import { fromString } from "./fable_modules/Thoth.Json.6.0.0/Decode.fs.js";
import { createObj, uncurry2 } from "./fable_modules/fable-library-js.4.17.0/Util.js";
import { Interop_reactApi } from "./fable_modules/Feliz.2.7.0/Interop.fs.js";
import { empty as empty_1, append, singleton, delay, toList } from "./fable_modules/fable-library-js.4.17.0/Seq.js";
import { mapIndexed, map as map_1 } from "./fable_modules/fable-library-js.4.17.0/Array.js";
import { demoReview, PostType, Post } from "./Post.js";
import { LoadingIndicator_skeleton, LoadingIndicator_postLoadingIndicator } from "./Components/Components.js";
import { Interop_reactApi as Interop_reactApi_1 } from "./fable_modules/Feliz.2.7.0/Interop.fs.js";
import { ResponsiveContainer, PieChart, Pie, Cell, Label, Legend } from "recharts";
import { month, day, dayOfWeek, parse } from "./fable_modules/fable-library-js.4.17.0/Date.js";
import { Time_monthToString, Time_dayOfWeekToString } from "./Components/Utils.js";

function InsiderTrades() {
    let elems_7, elems, children, elems_1, elems_6, value_16, value_17, elems_5, value_19, elems_4, elems_2, elems_3;
    const patternInput = useFeliz_React__React_useState_Static_1505(undefined);
    const demoPosts = patternInput[0];
    useReact_useEffectOnce_3A5B6456(() => {
        const pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            let decoder, data_1, caseStrategy_2, extra_2;
            return ((decoder = Auto_generateBoxedDecoder_Z6670B51(array_type(Post_$reflection()), undefined, undefined), (data_1 = undefined, (caseStrategy_2 = undefined, (extra_2 = undefined, (() => {
                let properties_2;
                try {
                    const properties_3 = Helper_withProperties(empty(), (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, caseStrategy_2, extra_2)(data_1_1))]), properties_2), data_1), properties_2)));
                    const pr = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch("/api/asset/insider-trade/demo", properties_3).then((_arg_1) => {
                        let response_1, decoder_1_1;
                        return ((response_1 = _arg_1, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(array_type(Post_$reflection()), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_1.text().then((_arg_2) => {
                            let matchValue;
                            return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_2), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                        })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                    }))));
                    return pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])]))));
                }
                catch (exn) {
                    return PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
                }
            })()))))).then((_arg_3) => {
                const res = _arg_3;
                if (res.tag === 0) {
                    patternInput[1](res.fields[0]);
                    return Promise.resolve();
                }
                else {
                    return Promise.resolve();
                }
            });
        }));
        pr_1.then();
    });
    return createElement("div", createObj(ofArray([["className", "landing-favorites-holder"], (elems_7 = [createElement("div", createObj(ofArray([["style", {
        width: 100 + "%",
    }], (elems = [(children = ofArray(["Enkel og informativ oversikt over ", createElement("strong", {
        children: ["innsidehandler"],
    })]), createElement("h2", {
        children: Interop_reactApi.Children.toArray(Array.from(children)),
    }))], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])]))), createElement("div", createObj(ofArray([["className", "landing-favorites-img"], (elems_1 = toList(delay(() => {
        let xs_1;
        if (demoPosts != null) {
            const y = demoPosts;
            return singleton((xs_1 = map_1((i) => createElement(Post, {
                compId: `${i.Id}-${i.Type}`,
                "type\'": new PostType(1, []),
                post: i,
            }), (y.length > 2) ? y.slice(0, 1 + 1) : y), react.createElement(react.Fragment, {}, ...xs_1)));
        }
        else {
            return singleton(LoadingIndicator_postLoadingIndicator());
        }
    })), ["children", Interop_reactApi.Children.toArray(Array.from(elems_1))])]))), createElement("div", createObj(ofArray([["className", "landing-favorites-text"], (elems_6 = [(value_16 = "aksje.io bruker kunstig intelligens (AI) for å hente ut strukturert informasjon om innsidehandler på Oslo børs og presenterer det for deg på en enkel og oversiktlig måte.", createElement("p", {
        children: [value_16],
    })), (value_17 = "Få info om antall aksjer, snittpris, innsider m.m for innsidehandler gjort i dine favorittaksjer. aksje.io genererer rapporter og statistikk rundt innsidehandler for aksjer som hjelper deg få bedre innsikt og gjøre bedre investeringer.", createElement("p", {
        children: [value_17],
    })), createElement("div", createObj(ofArray([["style", {}], (elems_5 = [(value_19 = "Motta push-varslinger ved nye innsidehandler og short-oppdateringer med aksje.io appen. Last ned fra Apple App Store eller Google Play Store.", createElement("p", {
        children: [value_19],
    })), createElement("p", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "center",
        gap: 20 + "px ",
    }], (elems_4 = [createElement("a", createObj(ofArray([["href", "https://apps.apple.com/app/aksje-io/id6448765436"], ["target", "_blank"], (elems_2 = [createElement("img", {
        src: "/images/app_store_download.svg",
    })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_2))])]))), createElement("a", createObj(ofArray([["href", "https://play.google.com/store/apps/details?id=io.aksje.app&pli=1"], ["target", "_blank"], (elems_3 = [createElement("img", {
        style: {
            height: 50,
        },
        src: "https://play.google.com/intl/en_us/badges/static/images/badges/no_badge_web_generic.png",
        alt: "Last ned fra Google Play Store",
    })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_4))])])))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_5))])])))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_6))])])))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_7))])])));
}

const demoData = [{
    name: "Kjøp",
    value: 42,
}, {
    name: "Svakt kjøp",
    value: 21,
}, {
    name: "Hold",
    value: 29,
}, {
    name: "Svakt salg",
    value: 27,
}, {
    name: "Selg",
    value: 19,
}];

function demoGraph() {
    let elems, props_9, props_8, x, props_7;
    return createElement("div", createObj(ofArray([["style", {
        height: 300,
        width: 300,
        fontSize: 0.7 + "rem",
        fontWeight: "bold",
        textTransform: "uppercase",
    }], (elems = [(props_9 = [["children", singleton_1((props_8 = [(x = [10, 0, 0, 30], ["margin", {
        bottom: x[2],
        left: x[3],
        right: x[1],
        top: x[0],
    }]), ["children", ofArray([Interop_reactApi_1.createElement(Legend, {}), Interop_reactApi_1.createElement(Label, {}), (props_7 = [["data", demoData], ["dataKey", "value"], ["children", ofArray([Interop_reactApi_1.createElement(Cell, {
        key: "Kjøp",
        fill: "var(--buy)",
    }), Interop_reactApi_1.createElement(Cell, {
        key: "Svakt kjøp",
        fill: "var(--weak-buy)",
    }), Interop_reactApi_1.createElement(Cell, {
        key: "Hold",
        fill: "var(--hold)",
    }), Interop_reactApi_1.createElement(Cell, {
        key: "Svakt salg",
        fill: "var(--weak-sell)",
    }), Interop_reactApi_1.createElement(Cell, {
        key: "Selg",
        fill: "var(--sell)",
    })])]], Interop_reactApi_1.createElement(Pie, createObj(props_7)))])]], Interop_reactApi_1.createElement(PieChart, createObj(props_8))))]], Interop_reactApi_1.createElement(ResponsiveContainer, createObj(props_9)))], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])])));
}

function shareAndExplore() {
    let elems_4, elems, children, elems_3, elems_1, elems_2, value_27, value_28;
    return createElement("div", createObj(ofArray([["className", "landing-header-holder"], (elems_4 = [createElement("div", createObj(ofArray([["style", {
        width: 100 + "%",
    }], (elems = [(children = ofArray([createElement("strong", {
        children: ["Oppdag og del "],
    }), "investeringsidéer"]), createElement("h2", {
        children: Interop_reactApi.Children.toArray(Array.from(children)),
    }))], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])]))), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-around",
    }], (elems_3 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
    }], (elems_1 = [demoGraph(), createElement("span", {
        style: {
            fontSize: 0.6 + "rem",
            fontStyle: "italic",
        },
        children: "* Graf kun for demonstasjon.",
    })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_1))])]))), createElement("div", createObj(ofArray([["className", "landing-header-text"], (elems_2 = [(value_27 = "Finn inspirasjon for dine neste investeringer fra analyser og innlegg publisert av brukere på aksje.io.", createElement("p", {
        children: [value_27],
    })), (value_28 = "Del dine egne tanker og analyser under dine favorittaksjer. Delta i diskusjoner og hjelp hverandre gjøre bedre investeringsvalg.", createElement("p", {
        children: [value_28],
    }))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_4))])])));
}

const demoShort = new Post_1(700, "short", "", new User(-1, "", false), "2023-05-03", {
    Market: "OSE",
    Name: "Nordic Semiconductor",
    Ticker: "NOD",
    Type: 1,
}, new PostShortInfo(443, 392, 7577259, 8566131, "2023-05-04", [new ShortEventPosition(9, "WorldQuant LLC", 1602364, 1602364), new ShortEventPosition(18, "JPMorgan Asset Management (UK) Ltd", 1489762, 1489762), new ShortEventPosition(19, "Sylebra Capital Limited", 3269501, 3269501), new ShortEventPosition(28, "Canada Pension Plan Investment Board", 1215632, 1215632), new ShortEventPosition(30, "BlackRock Investment Management (UK) Limited", 0, 988872)]), undefined);

function favorites() {
    let elems_3, elems, children, elems_1, elems_2, value_16, value_18;
    return createElement("div", createObj(ofArray([["className", "landing-favorites-holder"], (elems_3 = [createElement("div", createObj(ofArray([["style", {
        width: 100 + "%",
    }], (elems = [(children = ofArray(["Analyser, innlegg, innsidehandler og short-oppdateringer for ", createElement("strong", {
        children: ["dine favorittaksjer"],
    }), " gjennom din ", createElement("strong", {
        children: ["feed"],
    })]), createElement("h2", {
        children: Interop_reactApi.Children.toArray(Array.from(children)),
    }))], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])]))), createElement("div", createObj(ofArray([["className", "landing-favorites-img"], (elems_1 = [demoReview(true, 4, "NOK 158.70"), createElement(Post, {
        compId: "demo-short",
        "type\'": new PostType(0, []),
        post: demoShort,
    }), demoReview(false, 8, "NOK 69.12")], ["children", Interop_reactApi.Children.toArray(Array.from(elems_1))])]))), createElement("div", createObj(ofArray([["className", "landing-favorites-text"], (elems_2 = [createElement("p", createObj(singleton_1((value_16 = "Marker aksjer som favoritt og nye analyser, innlegg, innsidehandler, utbytteannonseringer og short-oppdateringer publisert på aksje.io vil dukke opp i din feed.", ["children", value_16])))), createElement("p", createObj(singleton_1((value_18 = "Vil du ha oppdateringer på 2 eller 20 aksjer? Det bestemmer du selv. Bygg din favorittliste slik som du selv ønsker.", ["children", value_18]))))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_3))])])));
}

function PreOpen() {
    let elems_10, elems_1, elems, children, elems_9, elems_6, elems_8, value_83, elems_7, value_86;
    const patternInput = useFeliz_React__React_useState_Static_1505(undefined);
    useReact_useEffectOnce_3A5B6456(() => {
        const pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            let decoder, data_1, caseStrategy_2, extra_2;
            return ((decoder = Auto_generateBoxedDecoder_Z6670B51(array_type(PreOpenMeta_$reflection()), undefined, undefined), (data_1 = undefined, (caseStrategy_2 = undefined, (extra_2 = undefined, (() => {
                let properties_2;
                try {
                    const properties_3 = Helper_withProperties(empty(), (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, caseStrategy_2, extra_2)(data_1_1))]), properties_2), data_1), properties_2)));
                    const pr = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch("/api/pre-open/latest", properties_3).then((_arg_1) => {
                        let response_1, decoder_1_1;
                        return ((response_1 = _arg_1, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(array_type(PreOpenMeta_$reflection()), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_1.text().then((_arg_2) => {
                            let matchValue;
                            return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_2), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                        })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                    }))));
                    return pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])]))));
                }
                catch (exn) {
                    return PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
                }
            })()))))).then((_arg_3) => {
                const res = _arg_3;
                if (res.tag === 0) {
                    patternInput[1](res.fields[0]);
                    return Promise.resolve();
                }
                else {
                    return Promise.resolve();
                }
            });
        }));
        pr_1.then();
    });
    return createElement("div", createObj(ofArray([["className", "preopen-holder"], (elems_10 = [createElement("div", createObj(ofArray([["style", {}], (elems_1 = [createElement("div", createObj(ofArray([["style", {
        width: 100 + "%",
    }], (elems = [(children = ofArray(["Les vår markedsoppdatering", createElement("strong", {
        children: [" \"Før børsåpning\" "],
    })]), createElement("h2", {
        children: Interop_reactApi.Children.toArray(Array.from(children)),
    }))], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])])))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_1))])]))), createElement("div", createObj(ofArray([["className", "preopen-content"], (elems_9 = [createElement("div", createObj(ofArray([["style", {
        width: 100 + "%",
        maxWidth: 420,
    }], (elems_6 = toList(delay(() => append(singleton(createElement("span", {
        style: {
            color: "var(--text-dim)",
            margin: 5,
            fontStyle: "italic",
        },
        children: "Siste \"Før børsåpning\"",
    })), delay(() => {
        let elems_5;
        const matchValue_1 = patternInput[0];
        if (matchValue_1 != null) {
            const x_1 = matchValue_1;
            return singleton(createElement("div", createObj(ofArray([["style", {
                display: "flex",
                flexDirection: "column",
                margin: 5,
                flexGrow: 1,
            }], (elems_5 = toList(delay(() => append(mapIndexed((i, y) => {
                let dateString;
                try {
                    const dt = parse(y.Date);
                    dateString = (`${Time_dayOfWeekToString(dayOfWeek(dt))} ${day(dt)} ${Time_monthToString(month(dt))}`);
                }
                catch (matchValue_2) {
                    dateString = y.Date;
                }
                return createElement("div", createObj(toList(delay(() => append(singleton(["className", "pre-open-entry"]), delay(() => append(singleton(["style", {
                    backgroundColor: ((i % 2) === 0) ? "var(--secondary-color)" : "var(--bg-dark)",
                }]), delay(() => append(!y.HasAccess ? singleton(["onClick", (_arg_4) => {
                }]) : empty_1(), delay(() => {
                    let elems_3;
                    return singleton((elems_3 = toList(delay(() => {
                        let elems_2;
                        return y.HasAccess ? singleton(createElement("a", createObj(ofArray([["className", "pre-open-link"], ["href", `/pre-open/${y.Date}`], (elems_2 = [createElement("span", {
                            children: [dateString],
                        })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_2))])])))) : append(singleton(createElement("span", {
                            className: "pre-open-link",
                            style: {
                                color: "var(--text-dim)",
                            },
                            children: dateString,
                        })), delay(() => singleton(createElement("span", {
                            className: "pre-open-link",
                            style: {
                                fontStyle: "italic",
                                userSelect: "none",
                                color: "var(--text-dim)",
                            },
                            children: "Krever aksje.io+",
                        }))));
                    })), ["children", Interop_reactApi.Children.toArray(Array.from(elems_3))]));
                }))))))))));
            }, x_1), delay(() => {
                let elems_4;
                return singleton(createElement("a", createObj(ofArray([["href", "/pre-opens"], ["style", {
                    marginTop: 10,
                    color: "#FFFFFF",
                }], (elems_4 = ["Se alle publiseringer", createElement("i", {
                    style: {
                        marginLeft: 5,
                    },
                    className: "fas fa-arrow-right",
                })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_4))])]))));
            })))), ["children", Interop_reactApi.Children.toArray(Array.from(elems_5))])]))));
        }
        else {
            return singleton(LoadingIndicator_skeleton(ofArray([["width", 100 + "%"], ["minHeight", 160]])));
        }
    })))), ["children", Interop_reactApi.Children.toArray(Array.from(elems_6))])]))), createElement("div", createObj(ofArray([["className", "landing-favorites-text"], (elems_8 = [createElement("p", createObj(singleton_1((value_83 = "Vi holder våre brukere oppdatert med siste nytt fra Oslo børs før hver handelsdag. Her får du siste oppdateringer fra selskaper notert på Euronext Oslo og Euronext Growth, oppdatering på markedsutvikling og informasjon om signifikante hendelser som kan påvirke markedet og enkeltaksjer.", ["children", value_83])))), createElement("p", createObj(singleton_1((elems_7 = [createElement("strong", {
        children: [" \"Før børsåpning\" "],
    }), (value_86 = "er tilgjengelig for alle, både registrerte og uregistrerte brukere, mandag og tirsdag. aksje.io+ brukere får tilgang hver eneste børsdag.", value_86)], ["children", Interop_reactApi.Children.toArray(Array.from(elems_7))]))))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_8))])])))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_9))])])))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_10))])])));
}

export function Highlights() {
    let elems;
    return createElement("div", createObj(ofArray([["style", {}], (elems = [createElement(InsiderTrades, null), createElement(PreOpen, null), favorites(), shareAndExplore()], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])])));
}

